export default __webpack_public_path__ + "static/media/image.help-lk.400fc478.png";